import { render, staticRenderFns } from "./top_sales.vue?vue&type=template&id=bb899978&scoped=true"
import script from "./top_sales.vue?vue&type=script&lang=js"
export * from "./top_sales.vue?vue&type=script&lang=js"
import style0 from "./top_sales.vue?vue&type=style&index=0&id=bb899978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_lodash@4.17.21_vue-template-compiler@2.7.16_webpack@5.90.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb899978",
  null
  
)

export default component.exports